"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExerciseCardBottomSection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const icons_1 = require("../../atoms/icons");
const typography_1 = require("../../shared/typography");
const ExerciseCardBottomSection = ({ translations, toggleHistory, historyVisible, onLeft, onRight, disabledLeft, disabledRight }) => {
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { disabledLeft: disabledLeft, disabledRight: disabledRight, children: [historyVisible && ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangleSmall", onClick: onLeft, color: disabledLeft ? "light-silver" : "grey", icon: ["fas", "caret-square-left"], size: "lg" }, void 0), (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangleSmall", onClick: onRight, color: disabledRight ? "light-silver" : "grey", icon: ["fas", "caret-square-right"], size: "lg" }, void 0)] }, void 0)), (0, jsx_runtime_1.jsx)(typography_1.P, { onClick: toggleHistory, children: historyVisible ? translations.close : translations.open }, void 0)] }, void 0));
};
exports.ExerciseCardBottomSection = ExerciseCardBottomSection;
const Wrapper = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  padding-bottom: 0;

  p {
    flex: 1;
  }

  & > p {
    color: ${({ theme }) => theme.colors.greyBase};
    cursor: pointer;
    font-size: 0.875rem;
    font-weight: 500;
    text-align: end;
    text-decoration: underline;
  }

  & > div {
    flex: 1;

    & > div {
      margin-right: ${({ theme }) => theme.spacings.s};
    }

    & > div:first-of-type {
      ${({ disabledLeft }) => disabledLeft ? "pointer-events: none" : ""};
    }

    & > div:last-of-type {
      ${({ disabledRight }) => disabledRight ? "pointer-events: none" : ""};
    }
  }
`;
//# sourceMappingURL=ExerciseCardBottomSection.js.map